export interface NewNonLoggedUserStatusResponse {
  newNonLoggedUser: boolean;
}

export const getNewNonLoggedUserStatus = async (
  accessAuthToken: string
): Promise<NewNonLoggedUserStatusResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/users/new-non-logged-user-status`;
  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${accessAuthToken}` },
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to get new non-logged user status");
  return response.json();
};

export const dismissNewNonLoggedUser = async (
  accessAuthToken: string
): Promise<NewNonLoggedUserStatusResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/users/new-non-logged-user-dismiss`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to dismiss new non-logged user onboarding");
  return response.json();
};
